export enum InventoryType {
    NonEquippable,
    Head,
    Neck,
    Shoulders,
    Shirt,
    Chest,
    Waist,
    Legs,
    Feet,
    Wrist,
    Hands,
    Finger,
    Trinket,
    OneHand,
    OffHand,
    Ranged,
    Back,
    TwoHand,
    Bag,
    Tabard,
    Chest2,
    MainHand,
    OffHand2,
    HeldInOffHand,
    Ammo,
    Thrown,
    Ranged2,
    Quiver,
    Relic,
    ProfessionTool = 29,
    ProfessionGear = 30,
}

export const weaponInventoryTypes: Set<InventoryType> = new Set<InventoryType>([
    InventoryType.HeldInOffHand,
    InventoryType.MainHand,
    InventoryType.OneHand,
    InventoryType.OffHand,
    InventoryType.OffHand2,
    InventoryType.Ranged,
    InventoryType.Ranged2,
    InventoryType.TwoHand,
]);
